import { inject } from '@angular/core';
import { APP_CONFIG } from '../../config/app-config';
import { HttpInterceptorFn } from '@angular/common/http';

export const deviceTimeZoneInterceptorFn: HttpInterceptorFn = (request, next) => {
  // Temporarily use the below check until the old API endpoints are migrated.
  const appConfig = inject(APP_CONFIG);
  const isRequestToNewApi = request.url.startsWith(appConfig.newApiUrl);
  if (isRequestToNewApi) {
    const newHeaders = request.headers.append('X-Device-Time-Zone', Intl.DateTimeFormat().resolvedOptions().timeZone);
    request = request.clone({ headers: newHeaders });
  }
  return next(request);
};
